import React from 'react';

import { useTranslation } from 'react-i18next';

import { useModals } from '@shared/contexts';

import { PromotionSimpleWinnerType } from '@types';

import { Modal } from '@components/modal';

import { ModalName } from '../types';
import * as Styled from './promotion-winner-list-modal.styled';

interface ModalDataType {
	winnerList: PromotionSimpleWinnerType[];
}

const PromotionWinnerListModal = () => {
	const { isModalOpen, closeModal, getModalData } = useModals();
	const { t } = useTranslation('promotions');

	const modalData = getModalData<ModalDataType>(ModalName.PROMOTION_WINNERS_LIST);

	return (
		<Modal
			title={t('WinnersList')}
			isOpen={isModalOpen(ModalName.PROMOTION_WINNERS_LIST)}
			closeModal={closeModal}
			noTitleBorder
		>
			<Styled.Wrapper>
				<Styled.ParticipantsGrid>
					{modalData?.winnerList.map((winner, index) => (
						<Styled.ParticipantsRow key={index}>
							<Styled.ParticipantNumber>{winner.position}</Styled.ParticipantNumber>
							<Styled.ParticipantId>{winner.user_pm_id}</Styled.ParticipantId>
						</Styled.ParticipantsRow>
					))}
				</Styled.ParticipantsGrid>
			</Styled.Wrapper>
		</Modal>
	);
};

export default PromotionWinnerListModal;
